
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports-liveviewing",
      function () {
        return require("private-next-pages/sports-liveviewing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports-liveviewing"])
      });
    }
  